screenSharePresenter.directive('screenSharePresenter', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                'screenshare_presenter/templates/' + helperService.getRedesignPathPrefix() + 'screenSharePresenter.html'
            ),
            link: function (scope, element, attrs, ngCtrl) {}
        };
    }
]);
